const Tick = ({ fill = '#FFFFFF' }: { fill?: string }) => {
    return (
        <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_776_9367)">
                <path
                    d="M9.25028 2.31348L5.11996 8.52825C4.99748 8.71255 4.73683 8.73835 4.58059 8.58163L1.60742 5.59919"
                    stroke={fill}
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_776_9367">
                    <rect
                        width="10"
                        height="10"
                        fill={fill}
                        transform="translate(0.607422 0.313721)"
                    />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Tick
